/**
 * Empeche l'ecran de se mettre en veille pendant la partie (utile sur
 * mobile) via la Screen Wake Lock API. Le navigateur relache tout seul le
 * verrou quand l'onglet perd le focus (ex: on change d'appli) ; on le
 * redemande automatiquement au retour, tant que release() n'a pas ete
 * appele explicitement.
 */
export class WakeLockController {
  private sentinel: WakeLockSentinel | null = null;
  private wanted = false;
  private onVisibilityChange = (): void => {
    if (this.wanted && document.visibilityState === "visible") void this.acquire();
  };

  constructor() {
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  }

  async acquire(): Promise<void> {
    this.wanted = true;
    if (!("wakeLock" in navigator) || this.sentinel) return;
    try {
      const sentinel = await navigator.wakeLock.request("screen");
      this.sentinel = sentinel;
      sentinel.addEventListener("release", () => {
        if (this.sentinel === sentinel) this.sentinel = null;
      });
    } catch {
      // Refuse (permission, onglet en arriere-plan...) : sans consequence, on retentera au besoin.
    }
  }

  release(): void {
    this.wanted = false;
    void this.sentinel?.release();
    this.sentinel = null;
  }

  destroy(): void {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    this.release();
  }
}
